import { LearnMoreLink, Page } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers, withPageProviders } from '../../../context/page-context';
import { PriceListCreateForm } from '../components/builder/price-list-create-form';
import { templateToInitialState, usePriceListTemplate } from '../hooks/use-price-list-templates';

export const PriceListCreatePage = withPageProviders(PriceListCreatePageContent);

function PriceListCreatePageContent() {
  const { navigationHandler } = useHandlers();

  const query = navigationHandler.query();
  const template = usePriceListTemplate(query?.template);

  return (
    <Page
      narrow
      title={t('price_list_builder.header.title.create')}
      description={
        <>
          {t('price_list_builder.header.description.create')}{' '}
          <LearnMoreLink link="https://docs.sparklayer.io/managing-pricing" />
        </>
      }
      backUrl="/pricing/lists"
    >
      <PriceListCreateForm
        draftState={template ? templateToInitialState(template) : undefined}
        onSuccess={() => navigationHandler.navigate('/pricing/lists')}
        onCancel={() => navigationHandler.navigate('/pricing/lists')}
      />
    </Page>
  );
}
